import React from "react";
import { useField } from "formik";
import { Box } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

interface Props {
  label?: string;
  name?: string;
  required?: boolean;
  placeholderText?: string;
  value?: any;
  dateFormat?: any;
}

export default function CustomDateInput(props: Props) {
  const [field, meta, helpers] = useField(props.name!);

  const handleChange = (date: Date | null) => {
    helpers.setValue(date);
  };

  return (
    <Box sx={{ mb: 2 }}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          label={props.label}
          value={field.value ? new Date(field.value) : null}
          onChange={handleChange}
          format={props.dateFormat || "dd.MM.yyyy"}
          enableAccessibleFieldDOMStructure={false}
          slotProps={{
            textField: {
              fullWidth: true,
              variant: "standard",
              error: meta.touched && !!meta.error,
              placeholder: props.placeholderText,
              helperText: meta.touched && meta.error ? meta.error : undefined,
            },
          }}
        />
      </LocalizationProvider>
    </Box>
  );
}
